const apiUrl = process.env.REACT_APP_APIURL

export default apiUrl;